import BaseLogger from './base-logger';
import BiLoadStartDataItem from './data-items/app-load/bi-load-start-item';
import BiPlatformLoadStartDataItem from './data-items/app-load/bi-platform-load-start-item';
import DurationDataItem from './data-items/duration/duration-item';
import BiPlatformLoadFinishDataItem from './data-items/app-load/bi-platform-load-finish-item';
import time from './time/time';
import appData from './app-data/app-data';
import performance from './performance/performance';

/**
 * Logs application load phases.
 *
 * Before adding new parameters to the reported events, please make sure the BI schema supports them:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */
export default class WidgetLogger extends BaseLogger {
  constructor(appName, appVersion, reporter, params) {
    super(appName, appVersion, reporter, params);

    this.widgetId = params.widgetId;
    this.isServerSide =
      params.isServerSide !== undefined ? params.isServerSide : null;
    appData.initApp(this.appName);
  }

  /**
   * Manual report for widget load start
   * Call this method at the earliest point possible when your widget starts loading
   */
  appLoadStarted() {
    time.setLoadStarted(this.appName);
    const dataSource = this.dataSource.clone();

    if (this.isServerSide !== null) {
      this.reporter.usePerformanceUrl();
      dataSource.addItem(
        new BiPlatformLoadStartDataItem(
          this.sessionId,
          this.appId,
          this.widgetId,
          this.isServerSide,
          this.metasiteId,
        ),
      );
    } else {
      this.reporter.useBaseUrl();
      dataSource.addItem(new BiLoadStartDataItem(this.sessionId));
    }

    return this._report(dataSource);
  }

  _getAppLoadedDataSource() {
    if (this.isServerSide !== null) {
      this.reporter.usePerformanceUrl();
      return this._getPlatformAppLoadedDataSource();
    }

    this.reporter.useBaseUrl();
    return BaseLogger.prototype._getAppLoadedDataSource.call(this);
  }

  _getPlatformAppLoadedDataSource() {
    const overrideDurationParamName = 'actionDurationMs';

    return this.dataSource
      .clone()
      .addItem(
        new BiPlatformLoadFinishDataItem(
          this.sessionId,
          this.appId,
          this.widgetId,
          this.isServerSide,
          this.metasiteId,
        ),
      )
      .addItem(new DurationDataItem(this.appName, overrideDurationParamName));
  }

  clearResourceTimings() {
    performance.clearResourceTimings();
  }
}
